const messages = {
  title: "Bridgestone <span class='text-danger'>PLUS</span> Shop",
  description: "Welkom in de Bridgestone PLUS Shop.<br/>Hier kunt u uw marketingpunten inwisselen voor mooie geschenken uit verschillende categorieën. Het assortiment wordt regelmatig bijgewerkt. Veel plezier bij het maken van uw keuze!<br/><br/>Heeft u een vraag? Bezoek dan onze Contact & Service pagina of <a href='/contact' class='text-danger'>klik hier</a>.",
  categoryPageDescriptionFallback: "Materiaal voor in de werkplaats of andere kwalitatieve producten met het Bridgestone-logo voor uw bedrijf",
  sort: {
    asc: "Sorteren op laagste prijs",
    desc: "Sorteren op hoogste prijs",
  },
  productSearchBox: {
    from: "van puntenwaarde",
    to: "tot puntwaarde",
  },
  noProducts: "De zoekcriteria leverden geen treffers op",
  quantity: "Aantal",
  search: "Zoek",
  perPage: "Items per pagina",
  timeUnavailable: "Momenteel niet beschikbaar op dat moment",
  product: "Product",
  cart: {
    pointsPerUnit: "Punten/eenheid",
    pointsSum: "Punten",
  },
  action: "Actie",
  pointsTotal: "Puntentotaal",
  cartRemainPoints: "Resterende punten",
  shoppingCart: "Winkelmand",
  emptyCart: "Winkelwagen is leeg.",
  attributes: "Kenmerken",
  selectAddressP: "Selecteer uw afleveradres",
  orderDelivery: "Leveringsadres",
  selectedProducts: "Geselecteerde producten",
  orderSummary: "Bestellingsoverzicht",
  contactPerson: "Contactpersoon",
  selectedAddress: "Geselecteerd adres",
  order: {
    success: "Bedankt! Uw bestelling is gelukt. U ontvangt binnen enkele minuten een orderbevestiging in uw inbox.",
    description: "Hier vindt u een overzicht van uw bestellingen in de BRIDGESTONE <span class='text-danger'>PLUS</span> SHOP.",
    info: "Hier vindt u een overzicht van uw bestellingen in de beloningswinkel.",
    date: "Besteldatum",
    number: "Bestelnr.",
    status: {
      created: "Gemaakt",
      confirm_order: "Bestelling bevestigen",
      ready_for_shipment: "Klaar voor verzending",
      rejected: "Afgewezen",
      processed: "Verwerkt",
      shipped: "Verzonden",
      returned: "Teruggestuurd",
      finished: "Klaar",
    },
    anyOrder: "Geen bestellingen",
    products: "Producten",
    quantity_short: "stuks",
    itemRemoved: "niet leverbaar",
  },
  orders: "Bestellingen Bridgestone <span class='text-danger'>PLUS</span> shop",
  notEnoughPoints: "U heeft onvoldoende marketing punten om dit item toe te voegen aan uw winkelmand.",
  statusText: "Status",
  outOfStock: "Momenteel niet op voorraad",
  productUnavailable: "Dit product is niet meer beschikbaar.",
  deletedProductsTitle: "Producten niet meer beschikbaar",
  deletedProductsMessage: "De volgende producten zijn niet meer beschikbaar. Verwijder ze uit je winkelmand om verder te gaan.",
  removeSelected: "Selectie verwijderen",
  clearCart: "Winkelmand legen",
  removeSelectedConfirm: "De geselecteerde producten uit je winkelmand verwijderen?",
  clearCartConfirm: "Alle producten uit je winkelmand verwijderen?",
  variant: "Varianten selecteerbaar",
  placeOrder: "BEVESTIG UW BESTELLING",
  toOrderDelivery: "Ga verder naar het afleveradres",
  toOrderSummary: "Verder naar bestellen",
  productImg: "Product afbeelding",
  selectAddressBtn: "Kies adres",
  categories: {
    advertising: {
      title: "Reclamemateriaal",
      desc: "Neem direct deel hier op het platform en verzamel <br /> 40 extra punten voor de beloningsclub.",
    },
    rewards: {
      title: "Exclusieve beloningen",
      desc: "Ontdek het bonusaanbod in ons trainingscentrum of bij u op locatie.",
    },
    tools: {
      title: "Werkplaats gereedschap",
      desc: "Gebruik uw punten voor <br /> trainingen van derden en verlaag uw kosten.",
    },
    trainings: {
      title: "Training & onderwijs",
      desc: "Ontdek het bonusaanbod in ons trainingscentrum of bij u op locatie.",
    },
    salesroom: {
      title: "Verkoopruimte",
      desc: "Richt de verkoopruimte in en bied uw klanten een aangenaam verblijf.",
    },
    hunter: {
      title: "Hunter",
      desc: "Inruilpunten voor aantrekkelijke werkplaatsinrichting van Hunter.",
    },
  },
  bestSold: "Meest verkocht",
  seasonal: "Seizoensgebonden",
  affordable: "Ontdek",
  forPoints: "{points} punten",
  reachedPoints: "Voldoende punten beschikbaar",
  remainingPoints: "Nog {points} punten nodig",
  incompleteAddress: {
    firstName: "Voeg een voornaam toe aan het afleveradres",
    lastName: "Voeg een achternaam toe aan het afleveradres",
    company: "Voeg een bedrijfsnaam toe aan het afleveradres",
    street: "Voeg een straat en huisnummer toe aan het afleveradres",
    postalCode: "Voeg een postcode toe aan het afleveradres",
    city: "Voeg een plaats toe aan het afleveradres",
    country: "Voeg een land toe aan het afleveradres",
    phone: "Voeg een telefoonnummer toe aan het afleveradres",
  },
  perPgae: "Items per pagina",
  favoriteProducts: {
    description: "Hier vindt u de producten die u heeft opgeslagen.",
  },
};
export default {
  messages,
};
